/**
 * CPV Q12-i · the audit-trail review's door to the server (`/bp/cpv/audit-trail/…`, QA only: POLICY cpv.audit_trail.review).
 *
 *   summary()           GET  …/summary/   → {allowed, policy, meaning, plants: [{plant, interval_days, since, due_at, overdue,
 *                                            last_review, next_period}], objects}
 *   trail(params)       GET  …/           → one page of the plants' CPV journal rows, newest first (?object=&event=&user=&from=&to=)
 *   options()           GET  …/options/   → {objects, events, people}: the filters' choices
 *   reviews(params)     GET  …/reviews/   → one page of the signed reviews, newest period first
 *   sign(body)          POST …/reviews/   {plant, from, to, comments, findings, esign, meanings_shown} → the review
 *
 * The client decides nothing: who may review, the schedule, every row and every refusal are the server's.
 */
import { get, post } from '../cpvMasterApi';

const BASE = '/cpv/audit-trail';

export const auditTrailApi = {
  summary: () => get(`${BASE}/summary/`),
  trail: (params) => get(`${BASE}/`, params),
  options: () => get(`${BASE}/options/`),
  reviews: (params) => get(`${BASE}/reviews/`, params),
  sign: (body) => post(`${BASE}/reviews/`, body),
};
